module.exports = __webpack_public_path__ + "img/ai-img-logo.4031bb4c.png";